module.exports = __webpack_public_path__ + "static/finish-5b2402a03469cbd673211855906a4a84.jpg";